import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import Badge from '../shared/atoms/Badge';
import Text from '../shared/atoms/Text';

const Card = styled.button`
  width: 100%;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'LTSaeada', Arial, sans-serif;

  &:hover {
    border-color: #5b5ff5;
    background: #f9fafb;
  }

  &:active {
    transform: scale(0.98);
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

const DayName = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
  text-transform: capitalize;
`;

const DateText = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
`;

const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;

const SlotCount = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CountBadge = styled.div`
  background: ${(props) => (props.hasSlots ? '#d5ff4f' : '#f3f4f6')};
  color: ${(props) => (props.hasSlots ? '#1f2937' : '#9ca3af')};
  font-size: 0.875rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 12px;
`;

const SelectedBadge = styled.div`
  background: #5b5ff5;
  color: white;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 10px;
`;

const CompactDayCard = ({ day, slots, selectedCount, onClick }) => {
  const dayMoment = moment(day.date);
  const dayName = dayMoment.format('dddd');
  const dateStr = dayMoment.format('DD MMMM');

  const availableSlots = slots.filter((s) => !s.full).length;
  const hasSlots = availableSlots > 0;

  return (
    <Card onClick={onClick}>
      <LeftSection>
        <DayName>{dayName}</DayName>
        <DateText>{dateStr}</DateText>
      </LeftSection>
      <RightSection>
        <SlotCount>
          <CountBadge hasSlots={hasSlots}>
            {availableSlots} créneau{availableSlots > 1 ? 'x' : ''}
          </CountBadge>
        </SlotCount>
        {selectedCount > 0 && (
          <SelectedBadge>
            {selectedCount} sélectionné{selectedCount > 1 ? 's' : ''}
          </SelectedBadge>
        )}
      </RightSection>
    </Card>
  );
};

CompactDayCard.propTypes = {
  day: PropTypes.object.isRequired,
  slots: PropTypes.array.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CompactDayCard;
